import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';

import AuthContext from '../Auth/AuthContext';
import configs from '../../../configs';
import isPasswordChangeRequired, { isChangePasswordRoute } from '../../Functional/auth/isPasswordChangeRequired';
import {
  clearLoginPasswordCheck,
  isLoginPasswordCheck,
  isPasswordChangePending,
  setPasswordChangePending,
} from '../../Functional/auth/passwordChangeSession';

const PasswordChangeRedirect = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const onChangePasswordPage = isChangePasswordRoute(location.pathname);
  const changePasswordPath = `${configs.prefix || ''}/change-password/`;

  useEffect(() => {
    if (!user) {
      return;
    }

    if (isLoginPasswordCheck()) {
      clearLoginPasswordCheck();

      if (isPasswordChangeRequired(user)) {
        setPasswordChangePending();

        if (!onChangePasswordPage) {
          navigate(changePasswordPath, { replace: true });
        }
      }

      return;
    }

    if (isPasswordChangePending() && !onChangePasswordPage) {
      navigate(changePasswordPath, { replace: true });
    }
  }, [user, onChangePasswordPage, navigate, location.pathname, changePasswordPath]);

  return children;
};

PasswordChangeRedirect.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PasswordChangeRedirect;
